import { useFlagship } from '@flagship.io/react-sdk';

export const useExperiment = (key, defaultValue) => {
  const { getFlag } = useFlagship();
  const flag = getFlag(key, defaultValue);
  const value = flag.getValue();
  return { value };
};
